export const TAG_TYPE = {
  default: 'default',
  primary: 'primary',
  warning: 'warning',
  danger: 'danger',
  success: 'success'
}
